import { Group, Skeleton } from '@mantine/core'

import type { BaseCategory } from 'src/types'

import { CategoryChip } from './CategoryChip'

type CategoryFilterProps = {
  categories: BaseCategory[]
  activeCategory: string
  onSelect: (id: string) => void
  loading: boolean
}

// Fallback palette for categories that have no CMS colour yet — keyed by
// position so a given category keeps the same dot across visits.
const FALLBACK_COLORS = [
  '#00b873',
  '#3d7abd',
  '#f59e0b',
  '#7c4dff',
  '#e8590c',
  '#e64980'
]

/**
 * Shared category filter rail — an "All" chip plus one colour-dotted chip per
 * category. Used by the policies and news listings.
 */
export const CategoryFilter = ({
  categories,
  activeCategory,
  onSelect,
  loading
}: CategoryFilterProps) => {
  if (loading)
    return (
      <Group gap="xs" wrap="wrap" mb="lg">
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} h={34} w={i === 0 ? 56 : 90 + i * 16} radius="xl" />
        ))}
      </Group>
    )

  return (
    <Group gap="xs" wrap="wrap" mb="lg">
      <CategoryChip
        label="All"
        active={activeCategory === 'all'}
        onClick={() => onSelect('all')}
      />
      {categories.map((category, index) => (
        <CategoryChip
          key={category.id}
          label={category.title}
          active={activeCategory === category.id}
          dotColor={
            category.color ?? FALLBACK_COLORS[index % FALLBACK_COLORS.length]
          }
          description={category.description}
          onClick={() => onSelect(category.id)}
        />
      ))}
    </Group>
  )
}
